/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { aiIntegrationsDeleteConfig } from "../funcs/aiIntegrationsDeleteConfig.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  DeleteAIIntegrationConfigRequest,
  DeleteAIIntegrationConfigSecurity,
} from "../models/operations/deleteaiintegrationconfig.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type DeleteAIIntegrationConfigMutationVariables = {
  request: DeleteAIIntegrationConfigRequest;
  security?: DeleteAIIntegrationConfigSecurity | undefined;
  options?: RequestOptions;
};

export type DeleteAIIntegrationConfigMutationData = void;

export type DeleteAIIntegrationConfigMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * deleteConfig aiIntegrations
 *
 * @remarks
 * Delete the org-wide AI integration config for a provider.
 */
export function useDeleteAIIntegrationConfigMutation(
  options?: MutationHookOptions<
    DeleteAIIntegrationConfigMutationData,
    DeleteAIIntegrationConfigMutationError,
    DeleteAIIntegrationConfigMutationVariables
  >,
): UseMutationResult<
  DeleteAIIntegrationConfigMutationData,
  DeleteAIIntegrationConfigMutationError,
  DeleteAIIntegrationConfigMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildDeleteAIIntegrationConfigMutation(client, options),
    ...options,
  });
}

export function mutationKeyDeleteAIIntegrationConfig(): MutationKey {
  return ["@gram/client", "aiIntegrations", "deleteConfig"];
}

export function buildDeleteAIIntegrationConfigMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: DeleteAIIntegrationConfigMutationVariables,
  ) => Promise<DeleteAIIntegrationConfigMutationData>;
} {
  return {
    mutationKey: mutationKeyDeleteAIIntegrationConfig(),
    mutationFn: function deleteAIIntegrationConfigMutationFn({
      request,
      security,
      options,
    }): Promise<DeleteAIIntegrationConfigMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(aiIntegrationsDeleteConfig(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
